import { Component, input } from '@angular/core';

@Component({
  selector: 'app-navigation-admin',
  templateUrl: './navigation-admin.component.html',
  styleUrl: './navigation-admin.component.scss',
})
export class NavigationAdminComponent {
  activeLink: string = '';
  

  // Method to set the active link
  setActive(link: string) {
    this.activeLink = link;
    //console.log(this.activeLink);
  }
}
